/** Explicit version keeps replacement assets distinct in browser caches. */
export const GARSON_BRAND = {
  mark: '/brand/garson-mark.svg?v=2',
  markInverse: '/brand/garson-mark-inverse.svg?v=2',
  wordmark: '/brand/garson-wordmark.svg?v=2',
  wordmarkInverse: '/brand/garson-wordmark-inverse.svg?v=2',
} as const;
